import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {map} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConsultarDocumentoService {

  constructor(private http: HttpClient) { }

  consulta(numeroProtocolo: string, dataAssinatura: string, token: string) {
    dataAssinatura = dataAssinatura.replace(/-/g, '');
    const url = "documento/" + numeroProtocolo;
    const params = { params:
      {
        dtAssinatura: dataAssinatura,
          token: token
      }, responseType: 'blob' as 'json'};
    console.log(dataAssinatura);
    return this.http.get<Blob>(url, params) // { responseType: 'blob' as 'json' }
      .pipe(
        map(res => new Blob([res], { type: 'application/pdf' }))
      );
  }
}
